import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { ISalesPriceKindEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ISalesPriceKindEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.salesPriceKind");

export const salesPriceKind = {
  ...getAllApis,
};
